import { computed, getCurrentInstance, onScopeDispose, shallowRef } from 'vue';
import ReportingCategoriesService from '@/api/services/reporting-categories.service';
import { reportingLeafOptions } from '@/domain/catalog/reporting-options';
import { IReportingCategory } from '@/interfaces/IReportingCategory';

/**
 * The store's reporting categories a product or category can use (the
 * leaves), loaded once for the editor. Empty when the store has none, or
 * when loading fails: the field then stays hidden.
 */
export function useReportingOptions(restaurantId: number | null) {
  const proxy = getCurrentInstance()?.proxy;
  const categories = shallowRef<IReportingCategory[]>([]);
  let disposed = false;
  onScopeDispose(() => {
    disposed = true;
  });

  if (restaurantId !== null)
    ReportingCategoriesService.getAll(restaurantId)
      .then((loaded) => {
        if (!disposed) categories.value = loaded;
      })
      .catch((error) => {
        console.error('Loading reporting categories failed', error);
      });

  const leaves = computed(() =>
    reportingLeafOptions(
      categories.value,
      proxy ? String(proxy.$i18n.locale) : undefined
    )
  );

  return { leaves };
}
